import React, { useEffect, useState } from "react";
import { SpinnerCircularFixed } from "spinners-react";
import ModalDisplay from "../Partials/ModalDisplay";
import Div from "../../components/common/Div";
import Text from "../../components/common/Text";
import { tenzero } from "../../constants/Constants";
import { CircularProgress } from "@mui/material";

export default function LoggingInBox(props) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  let displayValue = "none";
  if (props.display) displayValue = "block";
  return (
    <ModalDisplay
      style={{
        display: "flex",
        flexDirection: "column",
        width: windowWidth >= 800 ? "50%" : "80%",
      }}
      display={displayValue}
    >
      <Div margin={tenzero}>
        <CircularProgress
          style={{
            color: "rgb(33, 42, 65)",
          }}
        />
      </Div>
      <Div margin={tenzero}>
        <Text color={"rgb(33, 42, 65)"} fontSize={"0.9rem"}>
          Logging in...
        </Text>
      </Div>
    </ModalDisplay>
  );
}
